/*
  Notes for future Jennifer:
  - want to allow user to edit a zone (NOT affecting the db), export it, and send it to me
  - add a dark mode toggle
*/

import { Component, ElementRef, ViewChild } from '@angular/core';
import * as L from 'leaflet';
import { HttpClient } from '@angular/common/http';
import { MultiPolygon } from 'geojson';
//import 'leaflet.draw';

@Component({
  selector: 'app-zone-manager',
  templateUrl: './zone-manager.component.html',
  styleUrl: './zone-manager.component.scss'
})
export class ZoneManagerComponent {
  private _mapContainer?: ElementRef<HTMLDivElement>;

  @ViewChild('mapBox', { static: false })
  set mapContainer(container: ElementRef<HTMLDivElement> | undefined) {
    this._mapContainer = container;

    if (container && this.isMapReady && !this.map) {
      this.loadMap();
    }
  }

  themeMode: 'dark' | 'light' = 'dark';
  loading = true;
  saving = false;
  errorMessage = '';

  selectedContact: string = '';
  selectedCountry: string = '';
  selectedZone: string = '';

  contactOptionsError: string = '';
  contactOptions: {contact_uuid: string, contact_organization: string, countries: string[]}[] = [];
  contactOptionsLoading: boolean = false;
  countryOptions: string[] = [];
  zoneOptions: {zone_source: string, zone_uuid: string | null, zone_id: string | null, zone_name: string | null}[] = [];

  zoneApiBaseURL = '/api/managers/manager_zones.php';

  defaultMaps: { [key: string] : L.MapOptions} = {
    'CAN' : {
      center: [51.1579, -106.6702],
      zoom: 4,
      zoomControl: true,
      scrollWheelZoom: true,
      doubleClickZoom: true,
      touchZoom: true,
      boxZoom: true
    },
    'USA' : {
      center: [37.6935, -97.3383],
      zoom: 4,
      zoomControl: true,
      scrollWheelZoom: true,
      doubleClickZoom: true,
      touchZoom: true,
      boxZoom: true
    }
  }
  map: any;
  zoneLayer?: L.GeoJSON;
  geom!: MultiPolygon;

  constructor(private http: HttpClient){}

  ngOnInit(){
    this.loadContactOptions();
  }

  loadContactOptions(){
    console.log('calling load contact options...')
    const contactOptionsUrl = this.zoneApiBaseURL + '?query_type=contacts_list';
    this.http.get<{file: string, code: number, success: boolean, data: string | {contact_uuid: string, contact_organization: string, countries: string[]}[]}>(contactOptionsUrl).subscribe(
      res => {
        if (res.code == 200){
          if(typeof res.data === 'object'){
            this.contactOptions = res.data;
          }
        }
      }
    )
  }

  get isMapReady(): boolean {
    return !!this.selectedContact && !!this.selectedCountry;
  }

  onContactSelectionChange(contactUuid: string): void {
    this.selectedContact = contactUuid || '';

    const contact = this.contactOptions.find(c => c.contact_uuid === contactUuid);

    if (contact !== undefined) this.loadCountries(contact.countries);

    if(!this.selectedContact){
      this.errorMessage = '';
      this.loading = false;
      return;
    }
  }

  loadCountries(countries: string[]){
    this.countryOptions = countries;
  }

  onCountrySelectionChange(country: string){
    console.log('a country has been selected')
    this.selectedCountry = country;
    this.loadZones();
    this.loadMap();
  }

  // load the list of zones
  loadZones(){
    console.log(`selected contact is: ${this.selectedContact}`);
    console.log(`selected country is: ${this.selectedCountry}`);
    if (!this.selectedContact || !this.selectedCountry) return;

    const zonesListUrl = this.zoneApiBaseURL + `?query_type=zones_list&contact_uuid=${this.selectedContact}&country=${this.selectedCountry}`;
    console.log(`url is: ${zonesListUrl}`)
    this.http.get<{ success: boolean, file: string, code: number, data: string | {zone_uuid: string, zone_name: string | null, zone_id: string | null, zone_source: string}[]}>(zonesListUrl).subscribe(
      res => {
        console.log(res)
        if (res.code == 200 && typeof res.data === 'object') this.zoneOptions = res.data;
      }
    )
  }

  onZoneSelectionChange(zone: string){
    this.selectedZone = zone;

    this.loadZone();
  }

  // load the geometry for selected zone
  loadZone(){
    console.log(this.selectedZone)
    if(!this.selectedZone) return;

    console.log('selected zone exists')

    // this is fine. there's a unique constraint on customer uuid and zone id/name in db
    const zone = this.zoneOptions.find(c => c.zone_uuid === this.selectedZone);
    console.log(zone)
    if(!zone) return;
    const zoneGeomUrl = this.zoneApiBaseURL + `?query_type=zone_geometry&zone_source=${zone.zone_source}&zone_uuid=${zone.zone_uuid}`;
    console.log(zoneGeomUrl)
    
    this.http.get<{file: string, success: boolean, code: number, data: string | {zone_uuid: string, zone_source: string, geom: MultiPolygon}}>(zoneGeomUrl).subscribe(
      res => {
        console.log(res)
        if (res.code == 200 && typeof res.data === 'object'){
          this.geom = res.data.geom;
          this.loadMap();
        }
      }
    )
  }

  // this runs after DOM is changed. you need to have your map loading function called in here because it's in a *ngIf
  // structural directives like *ngIf are being phased out. for Angular 20+, use "Angular Control Flow" (aka the @ stuff) instead
  ngAfterViewChecked(){
    // if (this.isMapReady && this.mapContainer){
    //   this.loadMap();
    // }
  }

  ngAfterViewInit(){
    if (this.isMapReady && this.mapContainer){
      this.loadMap();
    }
  }

  loadMap(){
    if (!this._mapContainer){
      console.log('map container not definedddd');
      return;
    }

    if (!this.geom && !this.map){
      console.log('defining the dang map...')
      this.map = L.map(
        this._mapContainer.nativeElement, 
        this.defaultMaps[this.selectedCountry]
      );
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; OpenStreetMap contributors'
      }).addTo(this.map);
      return;
    } 
    

    if(this.zoneLayer) this.zoneLayer.remove();

    if(this.geom){
      console.log('loading zone layer...')
      this.zoneLayer = L.geoJSON(this.geom, {
        style: {
          color: 'purple',
          weight: 2,
          fillOpacity: 0.2
        }
      }).addTo(this.map);

      this.map.fitBounds(this.zoneLayer.getBounds());
    }

  }

  duplicateZoneAndModify(){
    // const drawnItems = new L.FeatureGroup();
    // this.map.addLayer(drawnItems);

    // const drawControl = new L.Control.Draw({
    //   edit: { featureGroup: drawnItems}
    // });

    // this.map.addControl(drawControl);
  }
}
